<template>
  <v-menu
    v-model="selectedOpen"
    :activator="selectedElement"
    :close-on-content-click="false"
    offset-x
  >
    <v-card color="grey lighten-4" flat max-width="600px" min-width="350px">
      <v-toolbar :color="selectedAction.color" dark style="color: black">
        <v-toolbar-title>
          <v-tooltip v-if="selectedAction.service" bottom>
            <template v-slot:activator="{ on, attrs }">
              <span v-bind="attrs" v-on="on"
                >{{ selectedAction.service.abbreviation }}:</span
              >
            </template>
            <span>{{ selectedAction.service.name }}</span>
          </v-tooltip>
          {{ selectedAction.name }}
        </v-toolbar-title>
        <v-spacer />
        <v-btn icon @click="redirectToActionChangePage(selectedAction.id)">
          <v-icon color="primary">
            mdi-pencil
          </v-icon>
        </v-btn>
      </v-toolbar>
      <v-card-text>
        <p>{{ selectedAction.durationStr }}</p>
        <p>{{ selectedAction.description }}</p>
        <p>Töötaja: {{ selectedAction.employeeNamesString }}</p>
        <p>Klient: {{ selectedAction.clientNamesString }}</p>
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn color="secondary" @click="selectedOpen = false" text>
          Sule
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-menu>
</template>

<script>
import { routerUrls } from '@/router'

/**
 * Renders a card to show details about an Action and a link to the editing from.
 */
export default {
  props: {
    value: { required: true }, // determine whether the dialog is open or not
    selectedAction: { required: true },
    selectedElement: { required: true }
  },
  computed: {
    selectedOpen: {
      get() {
        return this.value
      },
      set(val) {
        this.$emit('input', val)
      }
    }
  },
  methods: {
    redirectToActionChangePage(actionId) {
      this.$router.push(`${routerUrls.updateAction}${actionId}`)
    }
  }
}
</script>

<style scoped></style>
